import $http from '$http'
import {
    lg,
    util
} from 'utils';

export default {
    methods: {
        financialAudit() {
            $http.post('api/Order/OrderAuditByFinance', this.auditFormData).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '审核成功！',
                        type: 'success'
                    });
                    this.dialogVisible = false;
                    this.$emit('reLoadData');
                });
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/Order/financialList/components/financialAuditView/services.js